import { type UserInterfaceFlag } from '@/__generated__/api.js';
import { type useUserInterfaceFlagsQuery } from '@/__generated__/relay/useUserInterfaceFlagsQuery.graphql.js';
import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';

export const useUserInterfaceFlags = ():
  | readonly UserInterfaceFlag[]
  | null => {
  const data = useLazyLoadQuery<useUserInterfaceFlagsQuery>(
    graphql`
      query useUserInterfaceFlagsQuery {
        visitor {
          userAccount {
            userInterfaceFlags
          }
        }
      }
    `,
    {},
  );

  return data?.visitor?.userAccount?.userInterfaceFlags ?? null;
};
